import { render, staticRenderFns } from "./vsNavbarTitle.vue?vue&type=template&id=abff2492&"
import script from "./vsNavbarTitle.vue?vue&type=script&lang=js&"
export * from "./vsNavbarTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vsNavbarTitle.vue"
export default component.exports